module.exports = "tr{height:85px}\n"